// App.tsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';

// Pages - Login
import LoginVendedorPage from './pages/LoginVendedor';

// Pages - Classificação
import ListaClassificacaoPage from './pages/ListaClassificacao';
import ListaClassificacaoPrevisaoPage from './pages/ListaClassificacaoPrevisao';
import ListaClassificacaoPedidoPage from './pages/ListaClassificacaoPedido';

// Pages - Produtos
import ListaProdutoPage from './pages/ListaProduto';
import ListaProdutoPrevisaoPage from './pages/ListaProdutoPrevisao';
import ListaItensPrevisao from './pages/ListaItensPrevisao';
import ListaProdutoPedidoPage from './pages/ListaProdutoPedido';


// Pages - Clientes
import ListaClientePage from './pages/ListaCliente';
import ListaClienteDetalhePage from './pages/ListaClienteDetalhe';
import CadClientePage from './pages/CadCliente';

// Pages - Carrinho
import CarrinhoPrevisaoPage from './pages/CarrinhoPrevisao';
import CarrinhoPedidoPage from './pages/CarrinhoPedido';

// Utilitários
import { SessionUtil } from '@utils';

// Contexts
import { SessionProvider } from '@contexts/SessionContext';
import { AuthProvider } from '@contexts/AuthContext';

// Tema centralizado
import theme from '@theme';

// Componente de proteção de rotas
interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const vendCodigo = SessionUtil.get('vendCodigo');

  if (!vendCodigo) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Componente principal
const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <SessionProvider>
          <Router>
            <Routes>
          {/* Rota de Login */}
          <Route path="/login" element={<LoginVendedorPage />} />

          {/* Rota Home - Redireciona para Classificações */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Navigate to="/classificacoes" replace />
              </ProtectedRoute>
            } 
          />

          {/* Rotas de Classificação */}
          <Route
            path="/classificacoes"
            element={
              <ProtectedRoute>
                <ListaClassificacaoPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/classificacoes-previsao"
            element={
              <ProtectedRoute>
                <ListaClassificacaoPrevisaoPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/classificacoes-pedido"
            element={
              <ProtectedRoute>
                <ListaClassificacaoPedidoPage />
              </ProtectedRoute>
            }
          />

          {/* Rotas de Produtos */}
          <Route 
            path="/produtos/:idClassificacao" 
            element={
              <ProtectedRoute>
                <ListaProdutoPage />
              </ProtectedRoute>
            } 
          />

          {/* Rotas de Produtos Previsão */}
          <Route 
            path="/produto-previsao/:idClassificacao" 
            element={
              <ProtectedRoute>
                <ListaProdutoPrevisaoPage />
              </ProtectedRoute>
            } 
          />

          {/* Rotas de Lista Produtos Previsão */}
          <Route 
            path="/itens-previsao" 
            element={
              <ProtectedRoute>
                <ListaItensPrevisao />
              </ProtectedRoute>
            } 
          />

          {/* Rotas de Produtos Pedido */}
          <Route 
            path="/produto-pedido/:idClassificacao" 
            element={
              <ProtectedRoute>
                <ListaProdutoPedidoPage />
              </ProtectedRoute>
            } 
          />

          {/* Rota alternativa para Produto Pedido (sem classificação) */}
          <Route 
            path="/produto-pedido" 
            element={
              <ProtectedRoute>
                <Navigate to="/produto-pedido/0" replace />
              </ProtectedRoute>
            } 
          />

          {/* Rotas de Clientes */}
          <Route 
            path="/clientes" 
            element={
              <ProtectedRoute>
                <ListaClientePage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/cliente/:codigo" 
            element={
              <ProtectedRoute>
                <ListaClienteDetalhePage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/cadastrar-cliente" 
            element={
              <ProtectedRoute>
                <CadClientePage />
              </ProtectedRoute>
            } 
          />

          {/* Rotas de Carrinho (futuro) */}
          {/* */}
          <Route 
            path="/carrinho-previsao" 
            element={
              <ProtectedRoute>
                <CarrinhoPrevisaoPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/carrinho-pedido" 
            element={
              <ProtectedRoute>
                <CarrinhoPedidoPage />
              </ProtectedRoute>
            } 
          />
          

          {/* Rota 404 - Not Found */}
          <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </SessionProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
